import ActionButtonRounded from 'Components/ActionButtonRounded';
import { Container, Item } from 'Components/Grid';
import HistoryRowSubHeader from 'Components/HistoryRowSubHeader';
import * as React from 'react';
import { useMyServiceContext } from '..';
import { supplyShortagesInquiry } from 'neuro-schemas';
import SuppliesHistoryWindow from './components/SuppliesHistoryWindow';
import type { ICapabilityContextProps } from 'Containers/CapabilityHandler';
import SuppliesHistoryTable from './components/SuppliesHistoryTable';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import { useAppSelector } from 'Store/index';
import browserLanguage from 'Utility/browserLanguage';

const { getLocalizations } = supplyShortagesInquiry;

const SuppliesHistory = ({ supplyShortagesInquiryDocs }: IOwnProps): React.JSX.Element => {
  const { fm, setEditingObj } = useMyServiceContext();
  const users = useAppSelector(s => s.session.orgUsers) ?? [];
  const locale = useAppSelector(s => s.settings.userSettings.uiLanguage) ?? browserLanguage;

  const fmSupplyShortagesInquiry = (id: string): string => {
    const localizations = getLocalizations(locale);
    if (!(id in localizations)) {
      // oxlint-disable-next-line no-console
      console.error(`fmSupplyShortagesInquiry: no id ${id}`);
      return '';
    }
    return localizations[id];
  };

  const historyData = supplyShortagesInquiryDocs.slice().sort(sortDocumentsDescending);

  const unresolvedDocs = historyData.filter(d => !d.status || d.status === 'pending');
  const resolvedDocs = historyData.filter(d => d.status === 'completed' || d.status === 'rejected');

  return (
    <React.Fragment>
      <Container style={{ justifyContent: 'space-between' }}>
        <Item>
          <HistoryRowSubHeader header={fm('myService.unresolvedSuppliesRequests')} />
        </Item>
      </Container>
      {unresolvedDocs.length > 0 ? (
        unresolvedDocs.map(d => (
          <SuppliesHistoryWindow
            key={d._id}
            supplyShortagesInquiryDoc={d}
            fmSupplyShortagesInquiry={fmSupplyShortagesInquiry}
          />
        ))
      ) : (
        <div style={{ marginBottom: '4.5rem' }}>
          <ActionButtonRounded
            text="myService.addNewSuppliesRequest"
            width={18}
            height={4}
            fontSize={16}
            onClick={() => setEditingObj({ type: 'supplyShortagesInquiry', data: {} })}
            uppercase={false}
            filled
          />
        </div>
      )}
      <Container style={{ justifyContent: 'space-between' }}>
        <Item>
          <HistoryRowSubHeader header={fm('myService.history')} />
        </Item>
      </Container>
      <SuppliesHistoryTable supplyShortagesInquiryDocs={resolvedDocs} users={users} />
    </React.Fragment>
  );
};

interface IOwnProps extends ICapabilityContextProps {
  supplyShortagesInquiryDocs: IDocumentWithTypeV2<'supplyShortagesInquiry'>[];
}

export default SuppliesHistory;
